import { LocalDate } from '@js-joda/core';

import { PregnancyCompletionType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { FormContextValues, Translate, useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

import { PatientPregnancyCompletionDatePicker } from './PatientPregnancyCompletionDatePicker';
import { PatientPregnancyCompletionTypeSelect } from './PatientPregnancyCompletionTypeSelect';

type PatientPregnancyCompletionMarkingFormBean = {
   completionType: PregnancyCompletionType | null;
   completionDate: LocalDate | null;
};

type PatientPregnancyCompletionMarkingFormChildrenRenderProps = Pick<
   FormContextValues<PatientPregnancyCompletionMarkingFormBean>,
   'handleSubmit' | 'formState'
>;

type PatientPregnancyCompletionMarkingFormProps = {
   readonly children: (renderProps: PatientPregnancyCompletionMarkingFormChildrenRenderProps) => JSX.Element;
};

export const PatientPregnancyCompletionMarkingForm = (
   props: PatientPregnancyCompletionMarkingFormProps
): JSX.Element => {
   const { register, formState, handleSubmit } = useFormController<PatientPregnancyCompletionMarkingFormBean>({
      completionType: null,
      completionDate: null,
   });
   return (
      <StyledFlex as={'form'} noValidate gap={'20px'} direction={'column'}>
         <Translate>{visitPatientPregnancyStatusTranslationKeys.shouldMarkPregnancyCompletion}</Translate>
         <PatientPregnancyCompletionTypeSelect register={register} />
         <PatientPregnancyCompletionDatePicker register={register} />
         {props.children({ formState: formState, handleSubmit: handleSubmit })}
      </StyledFlex>
   );
};
